import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import * as actions from '../../redux/actions/user'
import { useMemo, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { logSentryError } from '~gatsby-theme-autonomy/services/sentry'

export function useSubscriptions() {
  const user = useSelector((state) => state.user, shallowEqual)
  const dispatch = useDispatch()

  const loadUserSubscriptions = useMemo(
    () => bindActionCreators(actions.loadUserSubscriptions, dispatch),
    [dispatch]
  )

  useEffect(() => {
    // Have to fetch this every time because the state doesn't get updated for
    // changes
    const tryCatchLoadSubscriptions = async () => {
      try {
        await loadUserSubscriptions()
      } catch (error) {
        logSentryError(error, { source: 'loadUserSubscriptions' })
      }
    }

    tryCatchLoadSubscriptions()
  }, [loadUserSubscriptions])

  return user.subscriptions
}
